
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog, DialogTitle, Button, LinearProgress, CircularProgress } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import FileContext from '../context/Context';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { set_image_upload_status } from "../store/image_upload";

const ImageUploadPopUp = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {
		auditID,

	} = useSelector((state) => state.imagesStore);
	const { image_upload_status } = useSelector((state) => state.imageUploadStore);
	const { capturedInspectionImages } = useContext(FileContext);
	console.log(image_upload_status,capturedInspectionImages)

	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [currentImage, setCurrentImage] = useState(null);
	const [proceedActive, setProceedActive] = useState(true);
	const azure_image_file_name = (audit_id, image_name, file_name) => {
		return `${audit_id}_${image_name}_${file_name}`
	}
	const axiosInstance = axios.create({
		timeout: 30000,
	});

	const upload_images_data_db = async (formData, image_name, maxRetries = 3) => {
		let attempt = 0;

		const tryUpload = () => {
			axiosInstance.post(
				"/process_data/upload_process_store_individually",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			)
				.then(response => {
					if (response.status === 200) {

						const res = {
							image_name: image_name,
							status: 1,
							type: "sql_upload_status"
						}
						dispatch(set_image_upload_status(res))

					}
					console.log("Successful", response.data);
				})
				.catch(error => {
					attempt++;
					if (attempt < maxRetries && (error.code === 'ECONNABORTED' || (error.response && error.response.status >= 500))) {
						console.log(`Attempt ${attempt} failed. Retrying in ${Math.pow(2, attempt)} seconds...`);
						// setTimeout(tryUpload, Math.pow(2, attempt) * 1000);
					} else {
						console.error("Max retries reached or non-retryable error:", error);
					}
				});
		};

		tryUpload();
	};
	const uploadCachedImageToAzure = async (fileName, image_name) => {
		try {
			const cache = await caches.open('image-cache');

			const cachedResponse = await cache.match(fileName);

			if (!cachedResponse) {
				throw new Error(`No cached image found with the key: ${fileName}`);
			}
			const imageBuffer = await cachedResponse.arrayBuffer();
			const blob = new Blob([imageBuffer], { type: 'image/png' });

			const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditImages/${fileName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

			const headers = {
				'Content-Type': 'image/png',
				'x-ms-blob-type': 'BlockBlob'
			};
			await axios.put(url, blob, { headers })
				.then(response => {
					if (response.status === 201) {
						const res = {
							image_name: image_name,
							status: 1,
							type: "azure_img_upload_status"
						}
						dispatch(set_image_upload_status(res))
					}
					console.log('File uploaded successfully. Status Code:', response.status);
				})
				.catch(error => {
					console.error('Error uploading file:', error);
				});
		} catch (error) {
			console.error('Error retrieving or uploading cached image:', error);
		}
	};
	const handleRetry = async () => {
		for(let image_name_key in image_upload_status)
		{ 
			console.log(image_name_key,"111",image_upload_status)
			console.log(image_upload_status[image_name_key].sql_upload_status,"112")
			const imageDetail = capturedInspectionImages.find(image => image.name === image_name_key);
			if(image_upload_status[image_name_key].azure_img_upload_status ===0 || image_upload_status[image_name_key].sql_upload_status === 0){
				console.log(image_name_key,"113")
				const fileName = azure_image_file_name(auditID, imageDetail.name, imageDetail.file.name)
				if (auditID) {
					const cache = await caches.open('image-cache');
					const cachedResponse = await cache.match(`${fileName}-metadata`);
					if (cachedResponse) {
						const cachedData = await cachedResponse.json();
						console.log(cachedData); // This will log the actual stored data
						const formData = new FormData();
						// formData.append("file", res.file);
		                if(image_upload_status[image_name_key].azure_img_upload_status ===0){
						uploadCachedImageToAzure(fileName, cachedData.name);
						}
						if(image_upload_status[image_name_key].sql_upload_status===0){
							formData.append("clickedTime", cachedData.clicked_time);
							formData.append("name", cachedData.name);
							formData.append("id", cachedData.type);
							formData.append("auditID", cachedData.audit_id);
							// formData.append("data", capturedImages360);
							formData.append("latitude", cachedData.latitude);
							formData.append("longitude", cachedData.longitude);
							formData.append("azure_image_name", fileName);
							upload_images_data_db(formData, cachedData.name);
						}
						console.log(image_name_key["sql_upload_status"],"121")
						
					} else {
						console.log('No cached data found');
					}
				}
		
				
				
			}
			if (
				image_upload_status[image_name_key].azure_img_upload_status === 1 &&
				image_upload_status[image_name_key].sql_upload_status === 1
			  ) {
				setCurrentImageIndex((prev) => {
				  if (prev <= 18) {
					console.log("155")
					return prev + 1;
				  } 
				//   else {
				// 	console.log("158")
				// 	return 18;
				//   }
				});
				
			  }
			  
		}
		


		// uploadImageDataToSql();
	};
	
	
	const handleProceed = async() => {
		const result2 = await axios.post("/create_audit/verify_token", { audit: auditID, processed: 1 });
		          console.log(result2)
		          navigate("/success");
		         
		navigate("/success");
	}
	const reload = "../camera-module/Reload.png";
    const correct = "../camera-module/Correct.png";
	useEffect(() => {
		if (currentImageIndex < capturedInspectionImages.length) {
			const currentImage = capturedInspectionImages[currentImageIndex];
			const { sql_upload_status, azure_img_upload_status } = image_upload_status[currentImage?.name] || {};

			if (sql_upload_status === 1 && azure_img_upload_status === 1) {
				setCurrentImageIndex((prev) => {
					if (prev <= 18) {
					  console.log("155")
					  return prev + 1;
					} 
					// else {
					//   console.log("158")
					//   return 18;
					// }
			})
			}

		}
		if (currentImageIndex === capturedInspectionImages.length) {
			setProceedActive(false)
		}
	}, [image_upload_status, currentImageIndex, capturedInspectionImages]);

	useEffect(() => {
		const currentImage = capturedInspectionImages[currentImageIndex];
		console.log(currentImage, "349");
		console.log(image_upload_status[currentImage?.name]?.sql_upload_status, "456")
		setCurrentImage(currentImage)
	}, [capturedInspectionImages, currentImageIndex])
console.log(currentImage,currentImageIndex,"190000")
	return (
		<Dialog
			open={true}
			maxWidth="100vw"
			PaperProps={{
				sx: {
					width: "650px",
					height: "23vh",
					padding: "0.6rem",
					paddingBottom: "0.8rem",
					borderRadius: "0.9rem",
					boxSizing: "border-box",
					position: "absolute",
					top: "20%",
					overflow: "hidden",
					"@media screen and (orientation: landscape)": {
						height: "43vh",
						top: "15%",
					},
					"@media screen and (max-width: 400px)": {
						width: "89%"
					},
				},
			}}
		>
			<DialogTitle sx={{ fontSize: "1rem", textAlign: "center", marginBottom: "1rem" }}>
				{currentImageIndex} / {capturedInspectionImages.length} images uploaded
			</DialogTitle>

			<div style={{ display: "flex", alignItems: "center", justifyContent: "center",gap: "1rem" }}>
				
					{/* <>
						<CircularProgress sx={{ color: "#FC350B", marginBottom: "1rem" }} />
						<p>{`Uploading ${currentImage?.name}...`}</p>
					</> */}
				

				
						
						<button   style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FC350B", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
							<img src={reload} style={{ width: "1rem", height: "1rem" }}></img>
							<p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.5rem", cursor: "pointer" }} onClick={handleRetry}>Retry</p>
						</button>
					
				
				<button disabled={proceedActive} style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FC350B", padding: "0rem 1.2rem", backgroundColor: "white", borderRadius: "5px", opacity: "0.9" }}>
					<img src={correct} style={{ width: "1rem", height: "1rem" }}></img>
					<p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.5rem", cursor: "pointer" }} onClick={handleProceed}>Proceed</p>
				</button>
			</div>

			<LinearProgress
				variant="determinate"
				value={(currentImageIndex / capturedInspectionImages.length) * 100}
				sx={{ marginTop: "2rem", height: "7px", backgroundColor: "#e0e0e0", "& .MuiLinearProgress-bar": { backgroundColor: "#FC350B" } }}
			/>
		</Dialog>
	);
};

export default ImageUploadPopUp;
